import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import { VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Header, PrivacyPermissionsSection } from '../Components';
import PrivacyPermissionsOverlayProps from '../PrivacyPermissionsOverlay.context';
import { PageEnums } from '../PrivacyPermissionsOverlay.Enums';
import styles from '../PrivacyPermissionsOverlay.styles';

class Intro extends Component {
  static contextType = PrivacyPermissionsOverlayProps;

  renderContent = () => (
    <>
      {this.context.introSections?.map((section, index) => (
        <PrivacyPermissionsSection index={index} key={index} section={section} />
      ))}

      <TouchableOpacity
        testID={FrameworkTestKeys.PPOReadButton}
        onPress={() => this.props.goToPage(PageEnums.PRIVACY)}
      >
        <VFText
          style={styles.readPrivacy(this.props.theme)}
          i18nKey={'privacy_permissions_read_privacy_policy'}
          testKey={FrameworkTestKeys.PPOIntroText}
        />
      </TouchableOpacity>
    </>
  );

  renderButtons = () => (
    <>
      <VFButton
        type="secondary"
        testID={FrameworkTestKeys.PPOAcceptButtonIntro}
        style={styles.button}
        title={'privacy_permissions_accept_all_settings'}
        onPress={() => this.props.onAcceptAll()}
      />
      <VFButton
        type="secondary"
        testID={FrameworkTestKeys.PPORejectButton}
        style={styles.button}
        title={'privacy_permissions_reject_all_settings'}
        onPress={this.props.onRejectAll}
      />

      <VFButton
        type="secondary"
        testID={FrameworkTestKeys.PPOOverlayButton}
        onPress={() => this.props.goToPage(PageEnums.SETTINGS)}
        style={[styles.button, styles.lastButton]}
        title={'privacy_permissions_set_settings'}
      />
    </>
  );

  render() {
    return (
      <>
        <Header />
        {this.renderContent()}
        {this.renderButtons()}
      </>
    );
  }
}

Intro.propTypes = {
  goToPage: PropTypes.func.isRequired,
  onRejectAll: PropTypes.func.isRequired,
  onAcceptAll: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

export default withTheme(Intro);
